<template>
  <tr>
    <td :colspan="colspan" class="py-16">
      <div class="flex items-center justify-center gap-1.5">
        <span
          v-for="i in 4"
          :key="i"
          class="h-2.5 w-2.5 rounded-full bg-primary dark:bg-primary-dark"
          :style="{ animationDelay: `${(i - 1) * 0.15}s` }"
        />
      </div>
    </td>
  </tr>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  colspan?: number
}>(), {
  colspan: 5,
})
</script>

<style scoped>
span {
  animation: dotBounce 0.8s ease-in-out infinite;
}

@keyframes dotBounce {
  0%, 100% {
    transform: translateY(0);
    opacity: 0.4;
  }
  50% {
    transform: translateY(-10px);
    opacity: 1;
  }
}
</style>
